import { useState, useEffect } from "react";
import { phoneNumberFormatting, getName } from "js/formatting";
import { useSelector } from "react-redux";
import { getAllOwnersFromParties, getImage } from "js/utilities";
import { useTranslation } from "react-i18next";

import UserAvatarDialog from "./Dialogs/UserAvatarDialog";

export default function ProfileCard() {
  const [openUserAvatarDialog, setOpenUserAvatarDialog] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [profileCardObj, setProfileCardObj] = useState({});
  const { policies } = useSelector((state) => state.data);
  const [policy, setPolicy] = useState();
  const { t } = useTranslation();
  useEffect(() => {
    if (policies && user) {
      setPolicy(policies.find((x) => x.contractID === user.contractId));
    }
  }, [policies, user]);
  useEffect(() => {
    if (policy) {
      let owners = getAllOwnersFromParties(policy?.parties);
      let party = owners?.find((x) => x.person?.taxId === user?.identityNumber);
      if (party) {
        setProfileCardObj({
          userAvatar: getImage("image11.png"),
          fullName: getName(party?.person),
          nameTitle: party?.person?.nameTitle ?? "",
          suiteNumber: party?.person?.suiteNumber ?? "",
          streetAddress: party?.address?.addressLine1 ?? "",
          cityStateAndZipCode: `${party?.address?.city ?? ""}, ${
            party?.address?.state ?? ""
          } ${party?.address?.postalCode?.substring(0, 5) ?? ""}`,

          homePhone: party?.phone?.phoneNumber ?? "",
          mobilePhone: user?.mobile,
          email:
            party?.email?.address === ""
              ? user?.emailId
              : party?.email?.address,
          // goal: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse rutrum lorem est, sit amet ultricies dolor lobortis sed. Quisque sollicitudin, orci eu ornare finibus, purus eros pellentesque nunc, ut convallis massa sem ut eros.`,
        });
      }
    }
  }, [policy, user]);

  return (
    <>
      <div className="container ui-component-spacing">
        <div className="ui-card p-4 xl:p-6">
          <div className="flex flex-col md:flex-row">
            <div className="flex-1">
              <div className="text-lg font-semibold">
                {profileCardObj?.fullName}
                <span className="ml-2 text-base font-normal">
                  {profileCardObj?.nameTitle}
                </span>
              </div>

              <hr />
              {/* <div className="text-xs font-bold mb-2">
                Insurance &amp; Investment Goals:
              </div>
              <p className="text-xs">{profileCardObj?.goal}</p>
              */}

              <div className="grid grid-cols-1 mt-4 gap-4 md:grid-cols-2 lg:grid-cols-4 lg:mt-6 xl:gap-6">
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("ProfileCard-addressText")}
                  </div>
                  <div className="text-sm font-semibold text-theme-text-secondary">
                    {/* <div>{profileCardObj?.agencyName}</div> */}
                    {profileCardObj?.suiteNumber && (
                      <div>{profileCardObj?.suiteNumber}</div>
                    )}
                    <div>{profileCardObj?.streetAddress}</div>
                    <div>{profileCardObj?.cityStateAndZipCode}</div>
                  </div>
                </div>
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("ProfileCard-mobilephoneText")}
                  </div>
                  <div className="text-sm text-theme-text-secondary font-semibold">
                    {phoneNumberFormatting(profileCardObj?.mobilePhone)}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("ProfileCard-homephoneText")}
                  </div>
                  <div className="text-sm text-theme-text-secondary font-semibold">
                    {profileCardObj?.homePhone && (
                      <>{phoneNumberFormatting(profileCardObj?.homePhone)}</>
                    )}
                  </div>
                </div>
                <div>
                  <div className="text-xs text-theme-text-tertiary">
                    {t("ProfileCard-emailText")}
                  </div>
                  <div className="text-xs text-theme-text-secondary font-semibold">
                    {profileCardObj?.email}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <UserAvatarDialog
        state={openUserAvatarDialog}
        setState={setOpenUserAvatarDialog}
      />
    </>
  );
}
